/** Password input with visibility toggle for the login forms. */
import { useId } from 'react';
import { useT } from '@/i18n/useT';
import LoginPasswordVisibilityIcon from '@/features/auth/LoginPasswordVisibilityIcon';

const LoginPasswordField = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  autoComplete,
  errorKey,
  showPassword,
  onToggleShow,
  labelAside = null,
}) => {
  const t = useT();
  const errorId = useId();
  const hasError = Boolean(errorKey);
  const toggleLabel = showPassword
    ? t('login.hidePassword', 'Hide password')
    : t('login.showPassword', 'Show password');

  return (
    <div className="login-field">
      <div className="login-field-label-row">
        <label htmlFor={id}>{label}</label>
        {labelAside}
      </div>
      <div className="login-password-input-wrap">
        <input
          id={id}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
          aria-invalid={hasError ? 'true' : 'false'}
          aria-describedby={hasError ? errorId : undefined}
        />
        <button
          type="button"
          className="login-password-toggle"
          onClick={onToggleShow}
          aria-label={toggleLabel}
          aria-pressed={showPassword}
          data-testid="login-password-toggle"
        >
          <LoginPasswordVisibilityIcon hidden={showPassword} />
        </button>
      </div>
      {hasError ? (
        <p id={errorId} className="login-field-error" role="alert">
          {t(errorKey, errorKey)}
        </p>
      ) : null}
    </div>
  );
};

export default LoginPasswordField;
